module.exports = __webpack_public_path__ + "static/media/Web-Devep.20c7c61e.png";